import { AssignmentImport } from './Import'
const { RoutesMap, AssignmentList, AddAssignment, UpdateAssignment } = AssignmentImport

const AssignmentRoute = () => {
    return [
        {
            path: RoutesMap.ASSIGNMENT_LIST.path,
            element: <AssignmentList />
        },
        {
            path: RoutesMap.ADD_ASSIGNMENT.path,
            element: <AddAssignment />
        },
        {
            path: RoutesMap.UPDATE_ASSIGNMENT.path,
            element: <UpdateAssignment />
        },
    ]
}

export default AssignmentRoute
